<template>
	<div id="downloadingBar">
   	<button id="downloadingButton">
      <a :href="dwnUrl" rel="nofollow">Скачать</a>
    </button>
	</div>
</template>

<script>

export default {
  name: 'DownloadingBar',
  props: ['url_dwld'],
  watch: {
    url_dwld(newUrl) { 
      this.dwnUrl = newUrl
      console.log('G', this.dwnUrl)
    }
  },
  data: function () {
  	return {
      dwnUrl: 'http://46.101.109.44/api/excel/v2/1568044237.xls'
  	}
  },
}
	
</script>

<style>

#downloadingBar {
	display: inline-flex;
	overflow: hidden;
	height: 100%;
	background-color: white;
	border-radius: 0px 0px 10px 10px;
}

#downloadingButton {
  width: 80px;
  height: 30px;
  margin: 16px 30px 10px 20px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  font-weight: bold;
  color: white;
  background-color: #9e9e9e;

  cursor: pointer;
}
	
</style>